import React from 'react'
import { colors } from '@mobi/component-library/Theme/Common'
import type { FollowMeSharedBet } from '@core/Areas/FollowMe/types'
import { SharedBetCard } from '@core/Areas/FollowMe/Components/Common/SharedBetCard'
import { trackFollowMeNotificationOpened } from '@core/Areas/FollowMe/helpers/analytics'

export const IncomingSharedBet: React.FC<{
  sharedBet: FollowMeSharedBet
  shouldAutoOpenQuickbet: boolean
}> = ({ sharedBet, shouldAutoOpenQuickbet }) => {
  const highlightRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!highlightRef.current) return

    trackFollowMeNotificationOpened(sharedBet.ticket.productName)

    const el = highlightRef.current
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    el.style.transition = 'outline 0.75s ease'
    el.style.outline = `2px solid ${colors.mariner[500]}`

    const timeMs = sharedBet.isResulted ? 6_000 : 2_500
    const timerId = window.setTimeout(() => {
      el.style.outline = '2px solid transparent'
    }, timeMs)

    return () => clearTimeout(timerId)
  }, [sharedBet])

  return (
    <SharedBetCard
      sharedBet={sharedBet}
      ref={highlightRef}
      shouldAutoOpenQuickbet={shouldAutoOpenQuickbet}
    />
  )
}
